
        import type { TemplateResult, TemplateRootPropsForTag } from 'Components/types';
type homeVehicleWidgetRTRootProps = TemplateRootPropsForTag<'div'>;
import { createElement as _createElement } from 'preact';
import { map as _map } from 'Utils/array';
import _translate from 'Utils/translate';
export default function homeVehicleWidgetRT(): TemplateResult<homeVehicleWidgetRTRootProps> {
    return _createElement('div', { 'className': 'cm_vehicle-widget cm_vehicle-widget__home' }, this.template === 'active' ? _createElement('div', {
        'className': 'cm_vehicle-widget_active cmTemplate_active',
        'key': '59'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_active__content' }, _createElement('div', { 'className': 'cm_vehicle-widget_active__title' }, 'What are you driving?'), _createElement('div', { 'className': 'cm_vehicle-widget_active__text cm_mobile-hide' }, 'Add your vehicle to get started'), _createElement('div', { 'className': 'cm_vehicle-widget_active__text cm_desktop-hide' }, 'Select your vehicle to get started')), _createElement('button', {
        'className': 'cm_vehicle-widget_active__button',
        'onClick': this.openDialog,
        'type': 'button',
        'tabIndex': '0'
    }, _createElement('span', {}, '\u2192'))) : null, this.template === 'locked' ? _createElement('div', {
        'className': 'cm_vehicle-widget_locked cmTemplate_locked',
        'key': '676'
    }, _createElement('div', { 'className': 'cm_vehicle-widget_locked__main' }, _createElement('div', { 'className': 'cm_vehicle-widget_locked__label' }, 'Your Vehicle'), _createElement('div', { 'className': 'cm_vehicle-widget_locked__base' }, this.vehicleBaseValues.join(' ')), _createElement('div', { 'className': 'cm_vehicle-widget_locked__extra' }, '\n        ', window.Convermax.getVehicleExtraValues(this.vehicle).join(' \u2022 '), '\n      ')), _createElement('button', {
        'className': 'cm_vehicle-widget_locked__edit',
        'onClick': this.openDialog,
        'type': 'button',
        'tabIndex': '0'
    }, '\n      Edit Vehicle\n    ')) : null);
}
        export const componentNames = []